import React from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Select, Tooltip } from 'antd';
import { PublicStatusTag } from '../../../elements/components/Tags';
import {
  faGripVertical,
  faPenToSquare,
} from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { pathTo } from '../../../Routes';
import QueryString from '../../../../../lib/QueryString';

const { Text } = Typography;

const optionsPublicStatus = [1, 2, 3];

const LearningAdminModuleSerieCard = ({
  item,
  handleValue,
  handleOpenConfirmationModal,
  history,
  partnershipId,
  view,
  activeKey,
  ...props
}) => {
  const editModuleSerie = () => {
    history.push(
      QueryString.append(
        pathTo('LearningAdminModuleSerieEditScreen', {
          id_partnership: partnershipId,
          id: item.id,
        }),
        { view, key: activeKey }
      )
    );
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div>
            <FontAwesomeIcon icon={faGripVertical} />
            <Text
              strong
              style={{
                fontSize: '16px',
                marginLeft: '10px',
              }}
            >
              {item.title}
            </Text>
          </div>
          <div
            style={{
              marginRight: '20px',
            }}
          >
            <Select
              defaultValue={item.public_status}
              bordered={false}
              showArrow={true}
              placement='bottomRight'
              onChange={(value) => handleValue(item.id, value)}
              style={{
                width: 'auto',
                minWidth: '60px',
                margin: 'auto 0',
              }}
            >
              {optionsPublicStatus.map((x) => (
                <Select.Option
                  key={x}
                  value={x}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <PublicStatusTag value={x} />
                </Select.Option>
              ))}
            </Select>

            {item.public_status === 3 ? (
              <FontAwesomeIcon
                onClick={() => {
                  handleOpenConfirmationModal(item.id);
                }}
                icon={faTrashCan}
                className='cursor-pointer module-action-icon-delete'
              />
            ) : (
              <Tooltip
                placement='topRight'
                title={t('learning_module_series_message_info_delete')}
                arrowPointAtCenter={true}
              >
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className='module-action-icon-delete-disabled'
                />
              </Tooltip>
            )}
            <FontAwesomeIcon
              icon={faPenToSquare}
              className='module-action-icon-edit cursor-pointer'
              onClick={(e) => editModuleSerie()}
            />
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleSerieCard);

Logger.log('silly', `LearningAdminModuleSerieCard loaded.`);
